import { Link } from "@inertiajs/react"
import { Sparkles, X } from "lucide-react"

import { Button } from "@/components/ui/button"

interface JustCreatedBannerProps {
  count: number
  onClear: () => void
}

export function JustCreatedBanner({ count, onClear }: JustCreatedBannerProps) {
  return (
    <div className="flex items-center justify-between gap-4 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 dark:border-blue-800 dark:bg-blue-950">
      <div className="flex items-center gap-3">
        <div className="flex size-8 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900">
          <Sparkles className="size-4 text-blue-600 dark:text-blue-400" />
        </div>
        <p className="text-sm font-medium text-blue-900 dark:text-blue-100">
          {count} flashcard{count !== 1 ? "s" : ""} just created
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Link href="/flashcards">
          <Button
            variant="outline"
            size="sm"
            className="border-blue-300 text-blue-700 hover:bg-blue-100 dark:border-blue-700 dark:text-blue-300 dark:hover:bg-blue-900"
          >
            View All
          </Button>
        </Link>
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={onClear}
          className="text-blue-600 hover:bg-blue-100 hover:text-blue-800 dark:text-blue-400 dark:hover:bg-blue-900 dark:hover:text-blue-200"
        >
          <X className="size-4" />
          <span className="sr-only">Dismiss</span>
        </Button>
      </div>
    </div>
  )
}
